import React, { useRef, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import styles from './styles.module.scss';

import { useClosePanelsOnMobileNavigation } from '../../../hooks/useClosePanelsOnMobileNavigation';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { toggleRightSidebar } from '../../../redux/reducers/leftRightPanelStatus.reducer';

const RightPanel = React.memo((props) => {
	const [
		leftPanelOpen,
		handleOpenLeftPanel,
		closeLeftPanel,
		rightPanelOpen,
		handleOpenRightPanel,
		closeRightPanel
	] = useOutletContext();
	const dispatch = useDispatch();
	const rightPanelStatus = useSelector((state) =>
		state.sidebarStatus ? state.sidebarStatus.right : false
	);

	const rightPanelRef = useRef(null);
	const toggleRightPanelBtnRef = useRef(null);

	useClosePanelsOnMobileNavigation();

	useEffect(() => {
		function handleRightPanelClickOutside(event) {
			if (
				rightPanelRef &&
				!rightPanelRef?.current?.contains(event.target) &&
				!toggleRightPanelBtnRef?.current?.contains(event.target) &&
				rightPanelOpen
			) {
				closeRightPanel();
			}
		}

		document.addEventListener('mousedown', handleRightPanelClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleRightPanelClickOutside);
		};
	}, [toggleRightPanelBtnRef]);

	useEffect(() => {
		function focusRightPanel(event) {
			if (event.keyCode === 82 && event.altKey) {
				const panelButtons = [
					...rightPanelRef.current.querySelectorAll(
						'button[class~="btn"], a[href], input, select, [tabindex]:not([tabindex="-1"])'
					)
				].filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));

				if (panelButtons) {
					panelButtons[0].focus();
				}
			}
		}

		document.addEventListener('keydown', focusRightPanel);

		return () => {
			document.removeEventListener('keydown', focusRightPanel);
		};
	});

	return (
		<>
			{isMobile ? (
				<>
					<button
						type="button"
						className={`${styles.showRightPanelBtn} ${
							rightPanelOpen ? styles.expanded : styles.collapsed
						}`}
						onClick={() => {
							closeLeftPanel();
							handleOpenRightPanel();
						}}
						id={'global-rightpanel-trigger'}
						aria-label={'Toggle Right Panel'}
						ref={toggleRightPanelBtnRef}
					>
						{rightPanelOpen ? (
							<i className="fas fa-angle-double-right"></i>
						) : (
							<i className="fas fa-angle-double-left" style={{ color: 'blue' }}></i>
						)}
					</button>
					<section
						id={styles.rightPanel}
						className={rightPanelOpen ? styles.expanded : styles.collapsed}
						ref={rightPanelRef}
						aria-label="Right Panel"
					>
						{props.children}
					</section>
				</>
			) : (
				<>
					<button
						type="button"
						className={`${styles.showRightPanelBtn} ${
							rightPanelStatus ? styles.show : styles.expanded
						}`}
						onClick={() => dispatch(toggleRightSidebar())}
						id={'global-rightpanel-trigger'}
						aria-label={'Toggle Right Panel'}
						ref={toggleRightPanelBtnRef}
					>
						{rightPanelStatus ? (
							<i className="fas fa-angle-double-left" style={{ color: 'blue' }}></i>
						) : (
							<i className="fas fa-angle-double-right"></i>
						)}
					</button>
					<section
						id={styles.rightPanel}
						className={rightPanelStatus ? styles.collapsed : styles.expanded}
						ref={rightPanelRef}
						aria-label="Right Panel"
					>
						{props.children}
					</section>
				</>
			)}
		</>
	);
});

export default RightPanel;
